import { Controller } from "@hotwired/stimulus"
import closeOtherDropdowns from "./close_other_dropdowns"

export default class extends Controller {
  static targets = ["button", "dropdown", "backdrop", "toggleButton", "toggleText"]

  toggle(event) {
    event.stopPropagation()
    closeOtherDropdowns(this.application, this.element)

    const isHidden = this.dropdownTarget.classList.contains("hidden")

    if (isHidden) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.backdropTarget.classList.remove("hidden")
    this.dropdownTarget.classList.remove("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "true")
    this.positionDropdown()
  }

  close(event) {
    if (this.dropdownTarget.classList.contains("hidden")) return

    this.backdropTarget.classList.add("hidden")
    this.dropdownTarget.classList.add("hidden")
    this.buttonTarget.setAttribute("aria-expanded", "false")
    this.clearPositioning()
    if (event?.type === "keydown") {
      event.preventDefault()
      this.buttonTarget.focus()
    }
  }

  positionDropdown() {
    const button = this.buttonTarget
    const dropdown = this.dropdownTarget
    const buttonRect = button.getBoundingClientRect()

    // Use fixed positioning to escape stacking contexts
    dropdown.style.position = 'fixed'
    dropdown.style.top = `${buttonRect.bottom + 4}px`
    dropdown.style.right = `${window.innerWidth - buttonRect.right}px`
    dropdown.style.left = 'auto'
  }

  clearPositioning() {
    const dropdown = this.dropdownTarget
    dropdown.style.position = ''
    dropdown.style.top = ''
    dropdown.style.right = ''
    dropdown.style.left = ''
  }

  async toggleExportable(event) {
    event.preventDefault()
    event.stopPropagation()

    const invoiceId = event.currentTarget.dataset.invoiceId
    const button = this.toggleButtonTarget

    button.disabled = true
    button.classList.add('opacity-50')

    try {
      // Include current URL params (company_id, etc.) for proper context
      const currentParams = new URLSearchParams(window.location.search)
      const response = await fetch(`/invoices/${invoiceId}/toggle_exportable?${currentParams.toString()}`, {
        method: 'PATCH',
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      })

      if (response.ok) {
        const turboStreamContent = await response.text()
        Turbo.renderStreamMessage(turboStreamContent)
        this.close()
      }
    } catch (error) {
      console.error('Error toggling exportable:', error)
    } finally {
      button.disabled = false
      button.classList.remove('opacity-50')
    }
  }
}
